import { useState, useEffect } from "react"
import { initI18next } from "../i18next"

export function useInitI18n(locale: string) {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    initI18next(locale).then(() => setIsLoading(false))
  }, [])

  return isLoading
}
